import { DialogRef } from '@angular/cdk/dialog';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgForm } from '@angular/forms';
import { BusinessAddress } from '@models/businesses';
import { Select } from '@ngxs/store';
import {
	BusinessAddressesDispatch,
	BusinessAddressesState,
} from '@state/business/address';
import { UserSelectors } from '@state/global/user';
import { Observable } from 'rxjs';

@Component({
	selector: 'app-chicago-firm-name-override',
	templateUrl: './chicago-firm-name-override.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class ChicagoFirmNameOverrideComponent {
	@Select(BusinessAddressesState.getAll) offices$: Observable<
		BusinessAddress[]
	>;
	@Select(UserSelectors.getCurrentUserIsAdmin) admin$: Observable<boolean>;

	constructor(
		private businessAddressesDispatch: BusinessAddressesDispatch,
		private dialogRef: DialogRef<ChicagoFirmNameOverrideComponent>,
	) {}

	onSubmit(form: NgForm) {
		const updates: Partial<BusinessAddress>[] = Object.entries(
			form.controls,
		).map(([key, value]) => ({
			id: key,
			chicagoFirmName: value.value ?? null,
		}));

		this.businessAddressesDispatch.UpdateAll(updates);
		this.dialogRef.close();
	}

	close() {
		this.dialogRef.close();
	}
}
